import { fetcherAmplify } from 'src/business/Libraries/Fetcher';
import ReferralRepositoryImpl from './ReferralRepositoryImpl';

const referralRepository = new ReferralRepositoryImpl(fetcherAmplify);

export { referralRepository };
